/** Sync auth session from API login responses (HttpOnly cookie + optional dev bearer). */
export function applySessionToken(data) {
    if (data?.token) {
        localStorage.setItem("loomara_token", data.token);
    } else {
        localStorage.removeItem("loomara_token");
    }
}

export function clearSessionToken() {
    localStorage.removeItem("loomara_token");
}
